module.exports = __webpack_public_path__ + "media/images/icon/icon_youtube_mono_dark-6c71c49451c2064a905f8302798e0280.png";